export const to_local_iso_string = (date: string|Date) =>{
    if(typeof date === 'string') date = new Date(date);
    return `${
        date.getFullYear()
    }-${
        (date.getMonth()+1).toString().padStart(2,'0')
    }-${
        date.getDate().toString().padStart(2,'0')
    }T${
        date.getHours().toString().padStart(2,'0')
    }:${
        date.getMinutes().toString().padStart(2,'0')
    }:${
        date.getMilliseconds().toString().padStart(2,'0')
    }.000Z`
}


// IN HOURS
export const get_date_difference = (d1?: Date|string, d2?: Date|string) =>{
    if(!d1 || !d2) return null;
    if(typeof d1 === 'string') d1 = new Date(d1.split(".")[0]);
    if(typeof d2 === 'string') d2 = new Date(d2.split(".")[0]);

    let start:Date, stop:Date;
    if(d1 <= d2){
        start = d1;
        stop = d2;
    }
    else{
        start = d2;
        stop = d1;
    }
    let diff = stop.getTime() - start.getTime();
    
    return parseFloat((diff / ( 1000 * 60 * 60 )).toFixed(2));
}

// 2020-03-01T00:00:00.000Z
// 2020-03-01T02:51:00.000Z